// DO NOT CHANGE: Importiere CSS
import './index.css';

/**
 * Hier können alle JS-Dateien importiert werden, die in der
 * Main-JS-Datei von Hermeneus registriert werden sollen.
 */

import UebungActivitasCreateComponent from "./vue/UebungActivitasCreateComponent.vue";
import UebungActivitasAbsolveComponent from "./vue/UebungActivitasAbsolveComponent.vue";
import UebungActivitasPrintComponent from "./vue/UebungActivitasPrintComponent.vue";

/**
 * Diese Funktion, die in der Hauptdatei der Hermeneus-Vue-App aufgerufen wird,
 * registriert alle Vue-Komponenten, die in diesem Modul enthalten sind.
 * Mit dem Zugriff auf die Vue-Instanz (=VueAppInstance) können auch
 * noch weitere Plugins, Direktiven, etc. registriert werden.
 * ACHTUNG: Keine asynchrone Registrierung von Komponenten, etc. möglich!
 * @param VueAppInstance
 */
export function initModule (VueAppInstance) {
    VueAppInstance.component('uebung-activitas-create-component', UebungActivitasCreateComponent);
    VueAppInstance.component('uebung-activitas-absolve-component', UebungActivitasAbsolveComponent);
    VueAppInstance.component('uebung-activitas-print-component', UebungActivitasPrintComponent);
    /* Hier weitere Komponenten registrieren */
}